import { render, staticRenderFns } from "./wtContinuousPagination.component.vue?vue&type=template&id=708d9849&"
import script from "./wtContinuousPagination.component.vue?vue&type=script&lang=js&"
export * from "./wtContinuousPagination.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports